import { primary, green, orange, magenta, raven, purple, gold, red, neutral, action, blue, externalBrand } from './colors';
export default {
  primary,
  green,
  orange,
  magenta,
  raven,
  purple,
  gold,
  red,
  neutral,
  action,
  blue,
  externalBrand
};
//# sourceMappingURL=index.js.map